<template>
    <div>
       <h4 class="title">合約中心</h4>
       <div class="member_content">
            <table class="table table-bordered">
                <caption>
                </caption>
                <thead>
                    <tr class="success">
                        <td>合約名稱</td>
                        <td>檔案</td>
                        <td></td>
                        <td>簽署時間</td>
                        <td>通過時間</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(row, index) in this.agreements">
                      <td>{{row.title}}</td>
                      <td>
                        <a :href="'https://files.i80.com.tw/erp_version/demo/upload_files/contract/'+row.contract" target="_blank">下載</a>
                      </td>
                      <td v-if="!row.signed_at">
                        <button type="button" class="btn btn-sm btn-info" :disabled="row.signed_status==1" @click="agreement_signed(row.id, row.title)">我已同意合約內容並申請</button>
                      </td>
                      <td v-else></td>
                      <td>{{row.signed_at}}</td>
                      <td v-if="row.signed_status==1">
                        {{row.confirm_at}}
                      </td>
                      <td v-else></td>
                    </tr>
                </tbody>
            </table>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Agreement',
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      agreements: []
    }
  },
  mounted: function () {
    this.$http.get(this.memberurl + '/agreement', {params: {token: this.token}}).then(function (res) {
      let data = res.body.lists
      this.agreements = data
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    agreement_signed (id, title) {
      if (confirm('確認同意並簽署「' + title + '」合約嗎？')) {
        this.$http.post(this.memberurl + '/agreement_signed', {
          id: this.userID,
          agreement_id: id,
          token: this.token
        }).then(function (res) {
          let status = res.body.data
          if (status === 200) {
            window.alert('簽署成功')
          } else {
            window.alert('簽署失敗')
          }
        }, function () {
          console.log('failed')
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Agreement.vue?400f2ec2